// extracted by mini-css-extract-plugin
module.exports = {"link":"_2wYm8","clickable":"N1N2o","svgRoot":"_3bLYT","nonScalingStroke":"_2OIRR","hasShadow":"_3hiPA","hasStroke":"Fspl4"};